import { Component, OnInit, inject } from '@angular/core';
import { MediaService } from '@exl-ng/mulo-core';
import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { SEOService } from '../core/seo.service';
import { PortalService } from './portal.service';
import { PortalHomepageSections } from '../shared/configurations/portal-homepage.constant';
import { CustomLinks } from '../shared/interfaces/research-portal/portal-configuration/homepage-configuration.interface';
import { ResearcherRecord } from '../shared/interfaces/researcher-record.interface';
import { PortalAdditionsComponent } from './portal-additions/portal-additions.component';
import { PortalFeaturedComponent } from './portal-featured/portal-featured.component';
import { PortalUsageComponent } from './portal-usage/portal-usage.component';
import { PortalResearchersComponent } from './portal-researchers/portal-researchers.component';
import { PortalDownloadMapComponent } from './portal-download-map/portal-download-map.component';
import { PortalFreeLinksComponent } from './portal-free-links/portal-free-links.component';
import { PortalFeaturedCollectionsComponent } from './portal-featured-collections/portal-featured-collections.component';
import { PortalIntroComponent } from './portal-intro/portal-intro.component';
import { PortalTitleComponent } from './portal-title/portal-title.component';

@Component({
    selector: 'esp-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss'],
    host: { class: 'esp-portal' },
    imports: [
        PortalTitleComponent,
        PortalIntroComponent,
        PortalFeaturedCollectionsComponent,
        PortalFreeLinksComponent,
        PortalDownloadMapComponent,
        PortalResearchersComponent,
        PortalUsageComponent,
        PortalFeaturedComponent,
        PortalAdditionsComponent,
    ],
})
export class PortalComponent implements OnInit {
    media = inject(MediaService);
    private configurationHandlerService = inject(ConfigurationHandlerService);
    private translate = inject(TranslateService);
    private SEOService = inject(SEOService);
    private portalService = inject(PortalService);

    pageTitle = '';
    sections = [];
    portalHomepageSections = PortalHomepageSections;
    customLink1: CustomLinks;
    customLink2: CustomLinks;
    customLink3: CustomLinks;
    customLink4: CustomLinks;
    customLink5: CustomLinks;
    isSearchActive = false;
    researchers = [];

    ngOnInit(): void {
        this.changeDocumentTitle();
        this.sections = this.configurationHandlerService
            .portalHomepageConfiguration()
            .filter((section) => section.active);
        this.isSearchActive =
            this.sections.find(
                (item) => item.code === PortalHomepageSections.SEARCH,
            ) !== undefined;

        this.initCustomLinks();
        this.loadFeaturedResearchers();
    }

    initCustomLinks() {
        this.customLink1 = this.getCustomLinksBySectionCode(
            PortalHomepageSections.CUSTOM_LINK_1,
        );
        this.customLink2 = this.getCustomLinksBySectionCode(
            PortalHomepageSections.CUSTOM_LINK_2,
        );
        this.customLink3 = this.getCustomLinksBySectionCode(
            PortalHomepageSections.CUSTOM_LINK_3,
        );
        this.customLink4 = this.getCustomLinksBySectionCode(
            PortalHomepageSections.CUSTOM_LINK_4,
        );
        this.customLink5 = this.getCustomLinksBySectionCode(
            PortalHomepageSections.CUSTOM_LINK_5,
        );
    }

    loadFeaturedResearchers() {
        const featuredResearchersIds = this.portalService
            .getHomepageSectionByCode(
                PortalHomepageSections.FEATURED_RESEARCHER,
            )
            .researchersList.filter((researcher) => researcher.active)
            .map((researcher) => {
                return researcher.id;
            });
        this.portalService
            .getFeaturedResearchers(featuredResearchersIds)
            .subscribe((data) => {
                this.researchers = data as ResearcherRecord[];
            });
    }

    getCustomLinksBySectionCode(code) {
        return this.portalService.getHomepageSectionByCode(code)?.links;
    }

    changeDocumentTitle() {
        this.translate
            .get('research.search.document.title', {
                value: this.configurationHandlerService.mainInstitutionName(),
            })
            .subscribe((res) => {
                this.SEOService.updateTitle(res);
                this.pageTitle = res;
            });
    }
}
